import { useApi } from '@api/ApiProvider'
import { useI18n } from '@i18n/I18nProvider'
import { useQuery } from '@tanstack/react-query'

// Los tres listados que pinta el mapa, en el idioma activo. Comparten caché con el resto de
// pantallas por su clave (p. ej. el aviso invalida ['trees']).
export const useMapData = () => {
	const api = useApi()
	const { locale } = useI18n()
	const trees = useQuery({ queryKey: ['trees', locale], queryFn: () => api.trees(locale) })
	const stages = useQuery({ queryKey: ['stages', locale], queryFn: () => api.stages(locale) })
	const pois = useQuery({ queryKey: ['pois', locale], queryFn: () => api.pointsOfInterest(locale) })
	return { trees, stages, pois }
}
